// extracted by mini-css-extract-plugin
export var box = "_4m-0";
export var check = "_4m-1";
export var checkboxButton = "_4m-6";
export var checkboxGroup = "_4m-5";
export var disabled = "_4m-7";
export var ghost = "_4m-9";
export var input = "_4m-2";
export var label = "_4m-4";
export var normal = "_4m-8";
export var uncheck = "_4m-3";